import {
  DashboardOutlined,
  SettingOutlined,
  UserOutlined,
  CloudServerOutlined,
  TeamOutlined,
  FormOutlined,
  FileTextOutlined,
  ScheduleOutlined,
  SolutionOutlined,
  AppstoreOutlined,
  AuditOutlined,
  UserAddOutlined,
  IdcardOutlined,
  MedicineBoxOutlined,
  DollarOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

// Resource constants (must match backend)
export const RESOURCES = {
  // Existing
  DASHBOARD: 'dashboard',
  USERS: 'users',
  DOCUMENTS: 'documents',
  BACKUPS: 'backups',
  // Clinic resources (must match backend/src/config/roles.js)
  CLINIC_LOCATIONS: 'clinic.locations',
  CLINIC_ROOMS: 'clinic.rooms',
  CLINIC_SERVICES: 'clinic.services',
  CLINIC_STAFF: 'clinic.staff',
  CLINIC_PATIENTS: 'clinic.patients',
  CLINIC_APPOINTMENTS: 'clinic.appointments',
  CLINIC_FORMS: 'clinic.forms',
  CLINIC_FORM_TEMPLATES: 'clinic.form_templates',
  CLINIC_FORM_PACKAGES: 'clinic.form_packages',
  CLINIC_FORM_ASSIGNMENTS: 'clinic.form_assignments',
  CLINIC_SOAP: 'clinic.soap',
  CLINIC_SOAP_TEMPLATES: 'clinic.soap_templates',
  CLINIC_SOAP_NOTES: 'clinic.soap_notes',
  CLINIC_BILLING: 'clinic.billing',
  CLINIC_REPORTS: 'clinic.reports',
  CLINIC_AUDIT_LOGS: 'clinic.audit_logs',
  CLINIC_SETTINGS: 'clinic.settings',
  CLINIC_ASSESSMENTS: 'clinic.assessments',
};

// Home & Reception
const dashboardNavTree = [{
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: 'Home',
  icon: DashboardOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-dashboard',
      path: `${APP_PREFIX_PATH}/dashboard`,
      title: 'Overview',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DASHBOARD, action: 'read' }
    },
    {
      key: 'app-practitioner-dashboard',
      path: `${APP_PREFIX_PATH}/my-dashboard`,
      title: 'My Schedule',
      icon: IdcardOutlined,
      breadcrumb: false,
      submenu: [],
    },
    {
      key: 'app-quick-checkin',
      path: `${APP_PREFIX_PATH}/quick-checkin`,
      title: 'Check-In Patient',
      icon: UserAddOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_PATIENTS, action: 'create' },
      adminOnly: true,
    },
    {
      key: 'app-checkins',
      path: `${APP_PREFIX_PATH}/checkins`,
      title: 'All Check-ins',
      icon: ScheduleOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_PATIENTS, action: 'read' },
      adminOnly: true,
    },
  ]
}];

// Patient Care
const clinicNavTree = [{
  key: 'clinic',
  path: `${APP_PREFIX_PATH}/clinic`,
  title: 'Patient Care',
  icon: TeamOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-patients',
      path: `${APP_PREFIX_PATH}/clinic/patients`,
      title: 'Patients',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_PATIENTS, action: 'read' }
    },
    {
      key: 'app-soap-notes',
      path: `${APP_PREFIX_PATH}/clinic/soap-notes`,
      title: 'SOAP Notes',
      icon: FileTextOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_SOAP, action: 'read' }
    },
  ]
}];

// Forms
const formsNavTree = [{
  key: 'forms',
  path: `${APP_PREFIX_PATH}/forms`,
  title: 'Forms',
  icon: FormOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-form-assignments',
      path: `${APP_PREFIX_PATH}/forms/assignments`,
      title: 'Submitted Forms',
      icon: SolutionOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_FORM_ASSIGNMENTS, action: 'read' }
    },
    {
      key: 'app-form-templates',
      path: `${APP_PREFIX_PATH}/forms/templates`,
      title: 'Form Templates',
      icon: FormOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_FORM_TEMPLATES, action: 'read' }
    },
    {
      key: 'app-form-packages',
      path: `${APP_PREFIX_PATH}/forms/packages`,
      title: 'Form Packages',
      icon: AppstoreOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_FORM_PACKAGES, action: 'read' }
    },
  ]
}];

// Billing
const paymentsNavTree = [{
  key: 'payments',
  path: `${APP_PREFIX_PATH}/payments`,
  title: 'Billing',
  icon: DollarOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-payments',
      path: `${APP_PREFIX_PATH}/payments`,
      title: 'Payments',
      icon: DollarOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_BILLING, action: 'read' },
    },
  ]
}];

// Reports
const reportsNavTree = [{
  key: 'reports',
  path: `${APP_PREFIX_PATH}/reports`,
  title: 'Reports',
  icon: BarChartOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-reports',
      path: `${APP_PREFIX_PATH}/reports`,
      title: 'Practice Reports',
      icon: BarChartOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_REPORTS, action: 'read' },
      adminOnly: true,
    },
  ]
}];

// Settings
const setupNavTree = [{
  key: 'setup',
  path: `${APP_PREFIX_PATH}/setup`,
  title: 'Settings',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-services',
      path: `${APP_PREFIX_PATH}/setup/services`,
      title: 'Services',
      icon: MedicineBoxOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_SERVICES, action: 'read' },
      adminOnly: true,
    },
    {
      key: 'app-staff',
      path: `${APP_PREFIX_PATH}/setup/staff`,
      title: 'Staff & Practitioners',
      icon: ScheduleOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_STAFF, action: 'read' },
      adminOnly: true,
    },
    {
      key: 'app-soap-templates',
      path: `${APP_PREFIX_PATH}/setup/soap-templates`,
      title: 'Note Templates',
      icon: FileTextOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_SOAP_TEMPLATES, action: 'read' }
    },
  ]
}];

// Admin
const adminNavTree = [{
  key: 'administration',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'Admin',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-users',
      path: `${APP_PREFIX_PATH}/admin/users`,
      title: 'Users & Accounts',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.USERS, action: 'read' }
    },
    {
      key: 'app-backups',
      path: `${APP_PREFIX_PATH}/admin/backups`,
      title: 'Backups',
      icon: CloudServerOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true,
    },
    {
      key: 'app-audit-logs',
      path: `${APP_PREFIX_PATH}/admin/audit-logs`,
      title: 'Activity Log',
      icon: AuditOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CLINIC_AUDIT_LOGS, action: 'read' }
    }
  ]
}];

const navigationConfig = [
  ...dashboardNavTree,
  ...clinicNavTree,
  ...formsNavTree,
  ...paymentsNavTree,
  ...reportsNavTree,
  ...setupNavTree,
  ...adminNavTree,
]

export default navigationConfig;
